import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserService } from '../providers/user.service';

@Injectable()
export class JwtAuthInterceptor implements HttpInterceptor {

  constructor(public _injector: Injector) {}


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userService = this._injector.get(UserService);

    // User is not authenticated
    if (!userService.isAuthenticated()) {
      return next.handle(req);
    }

    const header: string = userService.buildAuthHeader();

    // Set auth header
    const authReq = req.clone({
      setHeaders: {
        Authorization: header
      }
    });

    return next.handle(authReq).pipe(
      tap((ev: HttpEvent<any>) => {
        // Not an HTTP response
        if (!(ev instanceof HttpResponse)) {
          return;
        }

        const response = <HttpResponse<any>> ev;

        // Response has token refresh header
        if (response.headers.has('Authorization')) {
          const refreshHeader = response.headers.get('Authorization');

          // Invalid header format
          if (!refreshHeader.startsWith('Bearer ')) {
            return;
          }

          // Refresh authorization
          userService.refreshAuth(refreshHeader.split(' ')[1]).subscribe();
        }
      })
    );
  }

}
